export const PERCENTAGES = [0, 10, 20, 30, 40, 50];

export const GRID_CLASSNAMES: Record<number, string> = {
  1: 'grid grid-cols-1',
  2: 'grid grid-cols-2',
  3: 'grid grid-cols-3',
  4: 'grid grid-cols-3 lg:grid-cols-4',
};

export const CUSTOM_FIELD_PROPS = {
  type: 'price',
  icon: 'pound',
  iconVariant: 'search',
  symbol: '',
  label: '',
  placeholder: 'e.g. £1,200.00',
  validation: {
    min: { value: 0, message: 'Amount must be great than £0' },
    required: {
      value: true,
      message: 'You must provide the deposit you would like to pay',
    },
  },
};
